import createClient from '@magalucloud/sdk-idmagalu-js';
import Vue from 'vue';

let clientIDMagalu = {};
const ID_TOKEN_KEY = 'id_magalu_id_token';
const ACCESS_TOKEN_KEY = 'id_magalu_access_token';
const sessionListeners = [];

const setSessionData = (key, data) => {
  sessionStorage.setItem(key, data);
};

const setHeaders = (request) => {
  const token = clientIDMagalu.getToken() || sessionStorage.getItem('token');
  request.headers.set('Authorization', `Bearer ${token}`);
  request.headers.set('Accept', 'application/json');
  request.headers.set('Content-type', 'application/json');
};

export const setTokenInSession = () => {
  setSessionData(ACCESS_TOKEN_KEY, clientIDMagalu.getToken());
  setSessionData(ID_TOKEN_KEY, clientIDMagalu.store.getItem(ID_TOKEN_KEY));
};

const notifySessionExpired = () => {
  if (sessionListeners.length === 0) {
    localStorage.removeItem('id_magalu_id_token');
    localStorage.removeItem('id_magalu_refresh_token');
    localStorage.removeItem('id_magalu_access_token');
    localStorage.removeItem('id_magalu_expires_in');
    clientIDMagalu.logout();
    window.location.reload();
  } else {
    sessionListeners.forEach((listener) => listener.onSessionExpired());
  }
};

const onResponse = (response) => {
  if (response.status === 401) {
    console.log('Sessão expirada mediante resposta 401.');
    notifySessionExpired();
  }
  return response;
};

export const authIDMagalu = {
  init() {
    return new Promise((resolve, reject) => {
      const clientId = process.env.VUE_APP_ID_MAGALU_CLIENT_ID || 'WwlEwdthnkwsX9XfrPbApVX8TbhwDfE8dUeSS9eMc0U';

      createClient({
        client_id: clientId,
        redirect_uri: `${window.location.origin}`,
        scope: 'openid',
        useRefreshTokens: true,
      })
        .then((resClient) => {
          clientIDMagalu = resClient;
          resolve(clientIDMagalu.isAuthenticated());
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getClientIDMagalu() {
    return clientIDMagalu;
  },
  registerSessionListener(listener) {
    if (listener.onSessionExpired) sessionListeners.push(listener);
  },
  login() {
    clientIDMagalu.login();
  },
  doLogout() {
    clientIDMagalu.logout();
    window.location.reload();
  },
  isAuthenticated() {
    return clientIDMagalu.isAuthenticated();
  },
  createInterceptors() {
    Vue.http.interceptors.push((request, next) => {
      const token = clientIDMagalu.getToken() || sessionStorage.getItem('token');
      if (token && clientIDMagalu.isAuthenticated()) {
        setTokenInSession();
        setHeaders(request);
        next((response) => onResponse(response));
        return;
      }

      console.log('Sessão expirada mediante expiração do token.');
      notifySessionExpired();
      next(request.respondWith('', { status: 401, statusText: 'Sessão expirada' }));
    });
  },
  removerDadosIdMagalu() {
    localStorage.removeItem('id_magalu_id_token');
    localStorage.removeItem('id_magalu_refresh_token');
    localStorage.removeItem('id_magalu_access_token');
    localStorage.removeItem('id_magalu_expires_in');
    localStorage.removeItem('xTenantId');
  },
  setTokenInSession,
};

const plugin = () => {
  Vue.prototype.$authIDMagalu = clientIDMagalu;
};

if (typeof window !== 'undefined' && window.Vue) { // eslint-disable-line no-undef
  window.Vue.use(plugin); // eslint-disable-line no-undef
}

export default plugin;
